<template>
  <div class="main-container">
    <ProgressBar v-if="!isGuestMode" class="progressbar" />
    <div class="store-page">
      <PageTitleBar
        title-id="store-page-title"
        title="Store"
        subtitle="Acquista Coin e scopri i piani più adatti alle tue esigenze."
        icon-class="fa-solid fa-cart-shopping"
        illustration-src="/Pagina Info/store.png"
        variant="store"
      />
      <div class="store-content">
        <div v-if="isGuestMode" class="guest-store-banner">
          <div class="guest-store-icon">
            <i class="fa-solid fa-gift"></i>
          </div>
          <span>Registrati per acquistare nello Store MyStudio</span>
        </div>
        <div class="section-content">
          <CoinPurchase
            variant="store"
            :guest-mode="isGuestMode"
            :current-plan="currentPlan"
            @coins-updated="fetchConversionCount"
          />
        </div>
      </div>
      <div
        v-if="isModalOpen"
        class="modal-overlay-abbonamenti"
        @click.self="closeModal"
        @keydown.esc="closeModal"
        tabindex="0"
      >
        <div class="modal-content-abbonamenti full-screen">
          <button class="close-button" @click="closeModal">
            <i class="fa-solid fa-times"></i>
          </button>
          <SubscriptionPurchase
            :loading="isProcessing"
            :guest-mode="isGuestMode"
            @storage-updated="fetchConversionCount"
            @plan-updated="updateCurrentPlan"
            @close="closeModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import ProgressBar from "../components/ProgressBar.vue";
import CoinPurchase from "@/components/CoinPurchase.vue";
import SubscriptionPurchase from "@/components/SubscriptionPurchase.vue";
import PageTitleBar from "@/components/PageTitleBar.vue";
import { isGuestMode } from "@/utils/guestMode";

export default {
  name: "MyStore",
  components: {
    ProgressBar,
    CoinPurchase,
    SubscriptionPurchase,
    PageTitleBar,
  },
  data() {
    return {
      isProcessing: false,
      storage: 0,
      selectedConversion: 1,
      conversionOptions: [
        { label: "Singolo Coin", value: 1 },
        { label: "Pacchetto 10", value: 10 },
        { label: "Pacchetto 50", value: 50 },
        { label: "Pacchetto 100", value: 100 },
      ],
      userEmail: "",
      message: "",
      creditiDisponibili: null,
      acquistoCompletato: false,
      puoFareAcquisti: false,
      isNotAcquistabile: false,
      creditiPerF24: 0,
      creditiPerProspettoPaghe: 0,
      coinToEuro: 0,
      prezzoPacchetto10: 0,
      prezzoPacchetto50: 0,
      prezzoPacchetto100: 0,
      currentPlan: "",
      isModalOpen: false,
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  computed: {
    isGuestMode() {
      return isGuestMode();
    },
  },
  async mounted() {
    if (this.isGuestMode) {
      this.creditiDisponibili = 0;
      return;
    }

    if (this.$route.query.success === "true") {
      this.message = "Pagamento completato con successo!";
      await this.fetchConversionCount();
    }
    await Promise.all([
      this.fetchConversionCount(),
      this.fetchPrezziConversione(),
      this.checkUserPermission(),
      this.fetchCurrentPlan(),
    ]);
  },
  methods: {
    selectConversion(value) {
      this.selectedConversion = value;
    },
    openSubscriptionModal() {
      this.isModalOpen = true;
      window.location.hash = "subscribe";
    },
    closeModal() {
      this.isModalOpen = false;
      if (window.location.hash === "#subscribe") {
        window.history.pushState(
          "",
          document.title,
          window.location.pathname + window.location.search
        );
      }
    },
    async checkUserPermission() {
      this.userEmail = localStorage.getItem("userEmail");
      if (!this.userEmail) {
        this.puoFareAcquisti = false;
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/user_permission`, {
          params: { email: this.userEmail },
        });
        this.puoFareAcquisti = response.data.puo_fare_acquisti;
      } catch (error) {
        console.error("Errore nel recupero permessi acquisto:", error);
        this.puoFareAcquisti = false;
      }
    },
    async fetchConversionCount() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get_conversion_count`
        );
        this.creditiDisponibili = response.data.crediti_disponibili;
      } catch (error) {
        console.error("Errore nel recupero del contatore:", error);
      }
    },
    async fetchPrezziConversione() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/getPrezziConversione`
        );
        this.creditiPerF24 = response.data.crediti_per_f24;
        this.creditiPerProspettoPaghe =
          response.data.crediti_per_prospetto_paghe;
        this.coinToEuro = response.data.prezzo_per_credito;
        this.prezzoPacchetto10 = response.data.prezzo_pacchetto_10;
        this.prezzoPacchetto50 = response.data.prezzo_pacchetto_50;
        this.prezzoPacchetto100 = response.data.prezzo_pacchetto_100;
      } catch (error) {
        console.error("Errore nel recupero dei prezzi conversione:", error);
      }
    },
    async fetchCurrentPlan() {
      try {
        const res = await axios.get(`${API_BASE_URL}/abbonamento`);
        this.currentPlan = res.data.current_plan;
      } catch (err) {
        console.error("Errore nel recupero piano:", err);
        this.currentPlan = "Base";
      }
    },
    updateCurrentPlan(plan) {
      this.currentPlan = plan;
    },
  },
};
</script>

<style scoped>
/* Piano corrente skeleton */
.skeleton-plan {
  font-size: 0.95rem;
  font-weight: 600;
  width: 5rem;
  height: 1.5rem;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  background: #fafafa;
  color: transparent;
  display: inline-block;
}
.main-container {
  display: flex;
  flex: 1 1 0;
  width: 100% !important;
  height: auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  box-sizing: border-box;
  background: #f7f9fb;
  font-family: "Inter", "Segoe UI Variable Text", "Segoe UI", sans-serif;
}

.store-page {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 100%;
  margin: 0;
  padding: clamp(0.65rem, 1.5vh, 1.1rem) clamp(1rem, 5vw, 6rem)
    clamp(0.55rem, 1vh, 0.9rem);
  overflow: visible;
}

.store-page > .page-title-bar {
  width: 100%;
  margin-inline: auto;
}

.progressbar {
  top: 1.5rem;
  right: 1.5rem;
  display: none;
}

.toggle-section {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.toggle-button {
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  font-family: ui-sans-serif, -apple-system, system-ui, Segoe UI, Helvetica,
    Apple Color Emoji, Arial, sans-serif, Segoe UI Emoji, Segoe UI Symbol;
  background: #ededf8;
  border-radius: 16px;
  color: #5d5bd0;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggle-button:hover {
  background: #e3e3ed;
}

.toggle-button i {
  font-size: 0.9rem;
}

.store-content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 0;
  width: 100%;
  min-height: 0;
  margin-top: 0.75rem;
}

.guest-store-banner {
  width: calc(53rem + 9rem);
  max-width: 100%;
  box-sizing: border-box;
  margin: 0.35rem auto 1rem;
  padding: 1rem 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  justify-content: center;
  text-align: center;
  border: 1px solid #dfe6e2;
  border-radius: 12px;
  background: #fbfdfb;
  box-shadow: 0 10px 26px rgba(22, 42, 34, 0.06);
}

.guest-store-icon {
  width: 2.6rem;
  height: 2.6rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef6f1;
  color: #216951;
  font-size: 1.12rem;
  flex: 0 0 auto;
}

.guest-store-banner span {
  margin: 0;
  color: #21382f;
  font-size: 1rem;
  line-height: 1.25;
  font-weight: 700;
}

.section-content {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  min-height: clamp(36rem, calc(100dvh - 18.5rem), 42rem);
  margin: 0 auto;
  transition: opacity 0.3s ease;
}
.current-plan-container-store {
  position: absolute;
  top: 20px;
  right: 10px;
  z-index: 10; /* Assicura che l'etichetta sia sopra il contenuto di CoinPurchase */
}

.current-plan-store {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.3rem 0.8rem;
  border-radius: 8px;
  letter-spacing: 0.3px;
  user-select: none;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.05);
  color: #444;
  transition: all 0.3s ease;
  font-family: ui-sans-serif, -apple-system, system-ui, Segoe UI, Helvetica,
    Apple Color Emoji, Arial, sans-serif, Segoe UI Emoji, Segoe UI Symbol;
  /* font-style: italic; */
  cursor: default;
}
.current-plan-store.plus {
  background: rgba(74, 77, 255, 0.12);
  color: #4a4dff;
}

.current-plan-store.premium {
  background: rgba(200, 161, 18, 0.15);
  color: #c8a112;
}

.modal-overlay-abbonamenti {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9); /* Sfondo opaco totale */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Elevato per coprire tutto */
  animation: fadeIn 0.3s ease;
}

.modal-content-abbonamenti.full-screen {
  background: #f9f9f9;
  border-radius: 0; /* Nessun bordo arrotondato */
  width: 100vw;
  height: 100vh;
  max-width: none; /* Occupa tutto */
  max-height: none;
  overflow-y: auto;
  box-shadow: none; /* Rimuovi ombra per full-screen */
  position: relative;
  animation: slideUp 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

.close-button {
  position: absolute;
  top: 3.2rem;
  right: 1.5rem;
  background: none;
  border: none;
  font-size: 1.3rem; /* Aumentato per visibilità */
  padding: 0.5rem 0.8rem 0.4rem 0.8rem;
  border-radius: 10px;
  color: #7d7d7d;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2001;
}

.close-button:hover {
  color: #5f5f5f;
  background-color: rgb(245, 245, 245);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 1050px) {
  .main-container,
  .store-page,
  .store-content,
  .section-content {
    height: auto;
    min-height: auto;
    overflow: visible;
  }

  .section-content {
    width: 100%;
  }

  .store-page > .page-title-bar {
    width: 100%;
  }
}

@media (max-width: 980px) {
  .store-page {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

@media (max-width: 768px) {
  .store-page {
    padding: 0.5rem 1rem;
  }
  .toggle-button {
    width: 100%;
    justify-content: center;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  .modal-content-abbonamenti.full-screen {
    padding: 1rem;
  }
}
</style>
